module.exports = __webpack_public_path__ + "static/media/gd.8f560e9c.svg";